import styled, { css } from 'styled-components'

import {
  color,
  radius,
  space,
  SpaceProps,
  spacing,
  typography,
} from '../../themes'

export type ContainerProps = SpaceProps

export const Container = styled.div<ContainerProps>`
  ${space}
  display: flex;
  gap: ${spacing(2)};
`

export const Page = styled.button<{ active?: boolean }>`
  ${typography('button2')};
  border-radius: ${radius('full')};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0;
  cursor: pointer;
  color: ${color('blue.01')};
  background-color: ${color('gray.06')};
  transition: background-color 0.2s ease, color 0.2s ease;

  ${({ active }) =>
    active &&
    css`
      color: ${color('white')};
      background-color: ${color('blue.01')};
      cursor: default;
    `}

  &:disabled {
    color: ${color('gray.03')};
    cursor: default;
  }
`

export const Dots = styled.div`
  ${typography('button2')};
  color: ${color('gray.03')};
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`
